<template>
<div id="employees"  class="content">
        <h4>{{ title }}</h4>
        <hr>
        <div class="row">
            <div class="col-sm-12">
                <router-link :to="`/${$i18n.locale}/employee/new`"><img src="../../assets/images/add_record.png" style="height: 22px; margin-bottom: 5px;"></router-link>
                <!--a href="" style="margin-left: 20px;"><u>IMPORT</u></a -->

                <a href="" @click.prevent="printPDF()" target="_blank"><img src="../../assets/images/print.png" alt="export to PDF" style="height: 22px; float: right; padding-left:8px"></a>
                <a href="" @click.prevent="getCSV"><img src="../../assets/images/download.png" style="height: 22px; float: right;"></a>

            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <v-card-title>

                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
                </v-card-title>

                <v-data-table
                    :headers="headers"
                    :items="users"
                    :pagination.sync="pagination"
                    :search="search"
                    class="elevation-1 fixed-header"
                >
                    <template slot="items" slot-scope="props">
                        <td class="justify-center layout px-0">
                            <v-icon
                                small
                                class="mr-2 pt-3"
                            @click="redirectTo('/' + $i18n.locale + '/employee/edit/' + props.item.id)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                small
                                class="pt-3"
                                @click="deleteEmployee(props.item, props.item.id, props.item.employee_name)"
                            >
                                delete
                            </v-icon>
                        </td>
                        <td class="text-xs-left">{{ props.item.employee_name }}</td>
                        <td class="text-xs-left">{{ props.item.company_shortname }}</td>
                        <td class="text-xs-left">{{ props.item.company_name }}</td>
                        <td class="text-xs-left">{{ props.item.email }}</td>
                        <td class="text-xs-left">{{ props.item.effective_at | formatDate }}</td>
                        <td class="text-xs-left">{{ props.item.effective_till | formatDate  }}</td>
                        <td class="text-xs-left">{{ props.item.id_number }}</td>
                        <td class="text-xs-center">{{ props.item.can_batch | toggleYN }}</td>
                        <td class="text-xs-center">{{ props.item.can_geolocation | toggleYN }}</td>
                        <td></td>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                    </template>
                </v-data-table>
            </div>
        </div>
</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'

import { enableToggle, yesNoToggle, checkNullVal } from '../common/toggle.js'

export default {
    data () {
        return {
            search: '',
            title: 'REGISTERED STAFF',
            headers: [
                    { text: 'ACTION' , sortable: false, value: 'action' },
                    { text: 'FULL NAME' , value: 'employee_name' },
                    { text: 'COMPANY ID' , value: 'companyId' },
                    { text: 'COMPANY NAME', value: 'companyName' },
                    { text: 'EMAIL', value: 'email' },
                    { text: 'ACTIVE FROM', value: 'activeFrom' },
                    { text: 'ACTIVE UNTIL', value: 'activeUntil' },
                    { text: 'ID' , sortable: false, value: 'id' },
                    { text: 'MANAGE BATCH CLOCKING', value: 'manageBatchClocking' },
                    { text: 'GEOFENCING', value: 'can_geolocation' },
                    { text: 'QR CODE', value: 'qrCode' },
            ],
            users: [],
            pagination: {'sortBy': 'activeFrom', 'sortBy': 'activeFrom', 'descending': true, 'rowPerPage': -1},

        }
    },

    methods: {
        loadUsers() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/user/list')
            .then(function (response) {
                vm.users = response.data.rec
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        redirectTo(path) {
            this.$router.push(path)
        },

        deleteEmployee(item, id, name) {
            var vm = this
            const index = vm.users.indexOf(item)

            if(confirm('Are you sure you want to delete ' + name + '?')) {
                axios.delete(this.$store.getters.rootAPI + '/employee/' +  id)
                .then(function (response) {
                    if (response.data.status === "error") {
                        alert("Cannot delete employee " + name + " because it is in used!")
                    } else {
                        vm.users.splice(index, 1)
                    }
                })
                .catch(function (error) {
                    alert('An error occured.')
                })
            }

            //confirm('Are you sure you want to delete this item?') && this.users.splice(index, 1)
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.users
            let data = []

            for (var i = 0; i < item.length; i++) {

                data.push({
                    FULL_NAME: item[i].employee_name,
                    STAFF_ID: item[i].staff_id,
                    NEWIC_NO: checkNullVal(item[i].card_id),
                    COMPANY_ID: item[i].company_shortname,
                    COMPANY_NAME: item[i].company_name,
                    EMAIL: item[i].email,
                    ACTIVE_FROM: moment(item[i].effective_at).format('YYYY-MM-DD'),
                    ACTIVE_UNTIL: moment(item[i].effective_till).format('YYYY-MM-DD'),
                    ID: checkNullVal(item[i].id_number),
                    PASSPORT_NUMBER: checkNullVal(item[i].passport),
                    PASSPORT_VALID_FROM: checkNullVal(item[i].passport_issued),
                    PASSPORT_VALID_TILL: checkNullVal(item[i].passport_expiry),
                    MANAGE_BATCH_CLOCKING: yesNoToggle(item[i].is_batch),
                    CAN_LOGIN: yesNoToggle(item[i].can_login),
                    GEOFENCING: yesNoToggle(item[i].can_geolocation),
                    QRCODE: '',
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.users

            var head = [
                { title: 'FULL NAME', dataKey: 'employee_name' },
                { title: 'STAFF ID', dataKey: 'staff_id' },
                { title: 'NEWIC NO', dataKey: 'newic' },
                { title: 'COMPANY ID', dataKey: 'company_shortname' },
                { title: 'COMPANY NAME', dataKey: 'company_name' },
                { title: 'EMAIL', dataKey: 'email' },
                { title: 'ACTIVE FROM', dataKey: 'effective_at' },
                { title: 'ACTIVE UNTIL', dataKey: 'effective_till' },
                { title: 'ID', dataKey: 'id_number' },
                { title: 'MANAGE BATCH CLOCKING', dataKey: 'is_batch' },
                { title: 'GEOFENCING', dataKey: 'can_geolocation' },
                { title: 'QR CODE', dataKey: 'qrCode' },
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
                body.push({
                        employee_name: item[i].employee_name,
                        staff_id: item[i].staff_id,
                        newic: item[i].card_id,
                        company_shortname: item[i].company_shortname,
                        company_name: item[i].company_name,
                        email: item[i].email,
                        effective_at: moment(item[i].effective_at).format('YYYY-MM-DD'),
                        effective_till: moment(item[i].effective_till).format('YYYY-MM-DD'),
                        id_number: item[i].id_number,
                        is_batch: yesNoToggle(item[i].is_batch),
                        //qrCode: item[i].qrCode,
                    })
            }
            doc.text(this.title, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.title + '.pdf')
        }
    },

    created() {
        this.loadUsers();
    }
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>



// WEBPACK FOOTER //
// src/components/employee/Employees.vue